const white = {
  primary: '#FFF',
  active: '#F2F5F7',
  hover: 'var(--color-white-hover)',
};

const black = {
  primary: '#333333',
};

const gray = {
  primary: '#E6EFF6',
  divider: '#E5EAF0',
};

const surface = {
  primary: 'var(--color-surface-primary)',
};

const graydark = {
  primary: '#8E9DA9',
};

const greenlight = {
  primary: '#79E195',
};

export const blue = {
  hover: '#0186BF',
  active: '#0186BF',
  primary: '#0C7BAA',
};

const red = {
  secondary: { hover: '#FADDDD', active: '#F1C9C8', primary: '#FFEFEF' },
  primary: {
    hover: '#E55653',
    active: '#D14A47',
    primary: '#FD6460',
  },
};

export const colors = {
  red,
  blue,
  gray,
  white,
  black,
  surface,
  graydark,
  greenlight,
};
